import React, { useState } from 'react';
import '../styles/components/FlexServicesSection.css';
import ServiceDetailModal from './ServiceDetailModal';

const FlexServicesSection = ({ flexTypes, title = "Our Premium Flex Printing Solutions", subtitle = "Discover our comprehensive range of specialized flex materials engineered for exceptional performance across all applications" }) => {
  const [showComparison, setShowComparison] = useState(false);
  const [selectedService, setSelectedService] = useState(null);

  const openServiceDetail = (service) => {
    setSelectedService(service);
  };

  const closeServiceDetail = () => {
    setSelectedService(null);
  };

  const handleViewPortfolio = () => {
    closeServiceDetail();
    const portfolioSection = document.getElementById('portfolio-section');
    if (portfolioSection) {
      setTimeout(() => portfolioSection.scrollIntoView({ behavior: 'smooth' }), 300);
    }
  };

  const handleGetQuote = () => {
    closeServiceDetail();
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      setTimeout(() => contactSection.scrollIntoView({ behavior: 'smooth' }), 300);
    }
  };

  return (
    <section className="services-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{title}</h2>
          <p className="section-subtitle">
            {subtitle}
          </p>
          <div className="section-controls">
            <button 
              className={`control-button ${!showComparison ? 'active' : ''}`}
              onClick={() => setShowComparison(false)}
            >
              View Services
            </button>
            <button 
              className={`control-button ${showComparison ? 'active' : ''}`}
              onClick={() => setShowComparison(true)}
            >
              Compare Services
            </button>
          </div>
        </div>
        
        {!showComparison ? (
          <div className="flex-grid-enhanced">
            {flexTypes.map((service) => (
              <div key={service.id} className="flex-card-enhanced" style={{ '--accent-color': service.color }}>
                <div className="card-header-enhanced">
                  <div className="card-icon-enhanced" style={{ backgroundColor: service.color }}>
                    <span className="icon">{service.icon}</span>
                  </div>
                  <h3>{service.title}</h3>
                  <span className="card-badge">Premium</span>
                </div>
                
                <div className="card-image-enhanced">
                  <img src={service.image} alt={service.title} />
                  <div className="image-overlay-enhanced">
                    <button 
                      className="quick-view-btn"
                      onClick={() => openServiceDetail(service)}
                    >
                      Quick View
                    </button>
                  </div>
                </div>
                
                <div className="card-content-enhanced">
                  <p className="card-description">{service.description}</p>
                  
                  {/* Removed Thickness and Durability specs as per user request */}
                  
                  <div className="best-for-modern">
                    <div className="best-for-header">
                      <span className="best-for-icon">🎯</span>
                      <span className="best-for-label">
                        Best For
                      </span>
                    </div>
                    <div className="best-for-tags-modern">
                      {service.bestFor.map((tag, index) => (
                        <span key={index} className="tag-modern">{tag}</span>
                      ))}
                    </div>
                  </div>
                  
                  <div className="card-actions">
                    <button 
                      className="primary-action-btn"
                      onClick={() => {
                        const portfolioSection = document.getElementById('portfolio-section');
                        if (portfolioSection) {
                          portfolioSection.scrollIntoView({ behavior: 'smooth' });
                        }
                      }}
                    >
                      <span className="btn-icon">🎨</span>
                      View Portfolio
                    </button>
                    <button 
                      className="primary-action-btn"
                      onClick={() => openServiceDetail(service)}
                    >
                      <span className="btn-icon">🔍</span>
                      Details
                    </button>
                    <button 
                      className="cta-action-btn"
                      onClick={() => {
                        const contactSection = document.getElementById('contact');
                        if (contactSection) {
                          contactSection.scrollIntoView({ behavior: 'smooth' });
                        }
                      }}
                    >
                      <span className="btn-icon">💬</span>
                      Get Quote
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="comparison-table">
            <div className="table-header">
              <div className="table-cell feature-header">Features</div>
              {flexTypes.map(service => (
                <div key={service.id} className="table-cell service-header" style={{ color: service.color }}>
                  {service.title}
                </div>
              ))}
            </div>
            
            {['Material', 'Thickness', 'Width', 'Durability', 'Applications'].map(feature => (
              <div key={feature} className="table-row">
                <div className="table-cell feature-name">{feature}</div>
                {flexTypes.map(service => (
                  <div key={service.id} className="table-cell feature-value">
                    {service.specifications[feature.toLowerCase()]}
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}
      </div>

      <ServiceDetailModal
        service={selectedService}
        isOpen={!!selectedService}
        onClose={closeServiceDetail}
        onViewPortfolio={handleViewPortfolio}
        onGetQuote={handleGetQuote}
      />
    </section>
  );
};

export default FlexServicesSection;
